module.exports = __webpack_public_path__ + "img/crop-450x300.2431c35a.jpg";